module.exports = __webpack_public_path__ + "img/symbol_17.fa0ab698.png";